import Tracking from "./component/Tracking";
import Images from "./component/Images"
import Header from "./component/Header";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from "./component/Main"


function App() {
  return (
      <>
        <BrowserRouter>
            <Header />
          <div className="App">
            <Routes>
                <Route path="/" element={ <Main />} />
                <Route path="/invoiceNo/:num" element={ <Tracking /> } />
                <Route path="/image" element={ <Images /> } />                
            </Routes>
          </div>
        </BrowserRouter>
      </>
  );
}

export default App;
